import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "btn"
  ]

  upload(event) {
    this.btnTarget.classList.add("disabled");
    this.element.submit();
  }
}
